import { createAction } from 'redux-actions';

const setModalBackgroundScrollY = createAction('SET_MODAL_BACKGROUND_SCROLLY', scrollY => {
	document.body.style.top = `-${scrollY}px`;
	document.body.className += ' no-scroll';
	return scrollY;
});

const restoreModalBackgroundScrollY = createAction(
	'RESTORE_MODAL_BACKGROUND_SCROLLY',
	globalTop => {
		document.body.className = document.body.className.replace(' no-scroll', '');
		document.body.style.top = 'unset';
		window.scrollTo(0, globalTop);
	},
);

export const openGlobalModal = createAction('OPEN_GLOBAL_MODAL', modal => ({ modal }));

// Set modal background scroll position
export const openGlobalModalEpic = (action$, store) =>
	action$.ofType('OPEN_GLOBAL_MODAL').map(() => {
		const { global: { window: { scrollY } } } = store.getState();

		return setModalBackgroundScrollY(scrollY);
	});

export const closeGlobalModal = createAction('CLOSE_GLOBAL_MODAL', modal => ({ modal }));

// Restore modal background scroll position after close modal
export const closeGlobalModalEpic = (action$, store) =>
	action$.ofType('CLOSE_GLOBAL_MODAL').map(() => {
		const { modal: { globalTop } } = store.getState();

		return restoreModalBackgroundScrollY(globalTop);
	});



// WEBPACK FOOTER //
// ./src/actions/modal.js